/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityAmplificationResponse } from '../../models/activity-amplification-response';

export interface GetActivityAmplifications$Params {
  id: number;
}

export function getActivityAmplifications(http: HttpClient, rootUrl: string, params: GetActivityAmplifications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityAmplificationResponse>>> {
  const rb = new RequestBuilder(rootUrl, getActivityAmplifications.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ActivityAmplificationResponse>>;
    })
  );
}

getActivityAmplifications.PATH = '/api/activities/{id}/amplifications';
